exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!../../assets/css/v10.giris.css"), "");

// module
exports.push([module.id, ".cls-1[data-v-3d2b7eb7]{fill:red}.cls-2[data-v-3d2b7eb7]{fill:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d2b7eb7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Giris/_route.vue
// module id = 680
// module chunks = 0